import axios from "axios"
import MyHttpServer from "../plugin/http"
import router from "../router/index";

export function tpx_app (config) {

  // 1.创建 axios 的实例
  const instance = axios.create({
    baseURL: MyHttpServer.server_ip,
    withCredentials: true
  })

  // 2.拦截器：拦截请求
  // 拦截请求,两个参数（箭头函数）：请求成功，请求拒绝。
  instance.interceptors.request.use(config => {
    // 用法1:修改 config中的信息，请求报文，
    //如添加token，修改header

    if (config.url !== "/login") {

      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      config.headers.Authorization = userInfo.token;
      // 请求头
      // console.log(config.headers);
    }
    return config  // 将对象返回出去
  }, err => { });

  // 拦截响应
  instance.interceptors.response.use(
    response => {
      console.log(response.data);
      const { errmsg, errno } = response.data
      if (errno == "4602" || errno == "4601") {
        // this.router.push({ path: "/login" });
        // console.log(router.app.$options);
        // console.log("响应码不符合");
        router.push({ name: 'login' })
        return response;
      } else { return response; }

    },
    error => {
      console.log("拦截响应出错");
      return Promise.reject(error);
    }

  );


  // 3.发送网络请求
  // instance(config).then(res => { resolve(res) }).catch(err => { reject(err) })
  return instance(config)

}

export function traver (config) {

  const instance = axios.create({
    baseURL: MyHttpServer.server_ip
  })
  return instance(config)

}

// export function request(config, success, failure) {
//     // 1.创建 axios 的实例
//     const instance = axios.create({
//         baseURL: "http://127.0.0.1:5000"
//     })
//     // 2.发送网络请求
//     instance(config).then(
//         res => {
//             success(res)
//         }
//     ).catch(
//         err => {
//             failure(err)
//         }
//     )
// }

// 使用
// const config = { url: "/home", }
// request(config, res => { console.log(res); }, err => { console.log(err); })